// @ts-strict-ignore
import { IonGrid } from '@ionic/react'
import InAppDirections from 'mobile_web/modules/map/components/InAppDirections'
import { RouteProfile } from 'mobile_web/modules/map/types'
import { getDirMode, getStyleProperty } from 'mobile_web/modules/platform'
import { SectionLocationContainer as Container, Screen } from 'mytours-read-common'
import { MapRoute } from 'mytours-read-api-typescript'
import React, { useState } from 'react'
import SectionHeader from '../SectionHeader'
import Content from './Content'
import MapModalComponent from 'mobile_web/modules/screen/components/parts/SectionLocation/MapModal'

import './styles.less'

interface OwnProps {
	screen: Screen
}

const SectionLocation: React.FC<OwnProps & Container.Props & Container.Actions> = ({
	section,
	item: collection = {},
	screen,
}) => {
	const [showMap, setShowMap] = useState<boolean>(false)
	const [showInAppDirections, setShowInAppDirections] = useState<boolean>(false)

	const margin = Number(getStyleProperty('--content-margin-horizontal'))

	const toggleMap = (): void => {
		setShowMap(!showMap)
	}

	return (
		<IonGrid className="section-location" dir={getDirMode()} style={{ margin: `${margin / 2}px ${margin}px` }}>
			<SectionHeader title={section.title} />
			<Content section={section} toggleMap={toggleMap} setShowInAppDirections={setShowInAppDirections} />
			{showMap && (
				<MapModalComponent
					details={section}
					showMap={showMap}
					section={section}
					toggleMap={toggleMap}
					containerType={'modal'}
					containerId={section.id}
					linkedType={MapRoute.LinkedTypeEnum.StorySection}
					collectionId={collection?.id}
					screen={screen}
				/>
			)}
			<InAppDirections
				showModal={showInAppDirections}
				activeItem={section}
				toggleModal={setShowInAppDirections}
				profileType={collection.tour_type as RouteProfile}
				containerType={'section'}
				containerId={section.id}
			/>
		</IonGrid>
	)
}

const SectionLocationComponent = Container.default(SectionLocation)
export default SectionLocationComponent as any
